import tableAdminOrganizationAgreements from "./tableAdminOrganizationAgreements";

export default {
    title: 'Organization Agreements',
    noArea:true,
    attributeName: 'agreements',
    getURL: 'organization/agreements',
    idAttribute: 'organizationId',
    createURL: 'organization/agreements/new',
    updateURL: 'organization/agreements/edit',
    removeURL: 'organization/agreements/delete', 

    sessionParams: [],
    // formConfig: [
    //   formAdminOrganizations,
    // ],
    tableConfig: tableAdminOrganizationAgreements,
    // autoUpdate: true,
  };
  